import React, { Fragment, useEffect, useState } from "react";
import HeaderComponent from "../common/HeaderComponent";
import { useResume } from "../../context/ResumeContext";
import { DASHBOARD_LINK, REVIEW_HEADING_LINK, APP_DOMAIN, REVIEW_EDUCATION_LINK, REVIEW_SKILLS_LINK, REVIEW_SUMMARY_LINK, REVIEW_WORKHISTORY_LINK ,STRENGTH_LEVEL} from '../../constants/constants';
import '../../assets/scss/app/blocks/reviews.scss';
import '../../assets/scss/app/blocks/traditional-editor.scss';
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import Resumes from "../resumetemplates/Resumes";
import { useResumePreviewSize } from "../common/useResumePreviewSize";
import BottomControls from "../common/BottomControls";
import { CrownBox } from "../common/CrownBox";
import PageLoader from "../common/PageLoader";
import { circleColor } from "../../helper";
const ReviewLandingPage = (props) => {
    const [width, height, scale] = useResumePreviewSize();
    const {
        resume,
        scanReviewSuggestions,
        handlers
    } = useResume();
    useEffect(() => {
        window.scrollTo(0, 0)
        setTimeout(()=>window.pageYOffset && window.scrollTo(0, 0),500)
    }, []);
    const percentage = resume.resume_review?.resume_score.total_points;
    const strengthLevel = resume.resume_review?.resume_score.strength_level;
    const SectionRow = ({ sectionid, label, url }) => {
    const hasError = Object.keys(scanReviewSuggestions(sectionid, null, true)).length > 0
    
    return <Link to={url} className="text-decoration-none"><div className="common-box" >
        <CrownBox />
        <div className="d-flex-row review-error-list">
            <img src={`${APP_DOMAIN}/assets/images/${hasError ? 'exclamation-circle.svg' : 'check-circle.svg'}`} />
            <h3>{label}</h3>
            {hasError ? 
                <div className="btn-fixnow">
                    <span>Fix Now</span>
                    <i className="icon-right-arrow"></i>
                </div> : 
                <div className="btn-fixnow transparent-btn">
                    <span>Go To Section</span>
                    <i className="icon-right-arrow"></i>
                </div>
            }
        </div>
    </div></Link>}
    // console.log(resume.resume_review);
    return (
        <Fragment>
            <HeaderComponent
                editorType={'traditional'}
                saveResume={handlers.onsaveResume}
                resumeLoaded={true}
                showSplash={true}
            />
            {resume.resume_review?.resume_score ?
                <div className="app-editor app-allinone app-review-container">
                    <div className="left-block app-reviews">
                        <div className="summary-block">
                            <div className="back-link">
                                <span className="back"><Link to={DASHBOARD_LINK}><img src={`${APP_DOMAIN}/assets/images/left-arrow.svg`} />Return to Dashboard  </Link></span>
                            </div>
                            <div className="info-box">
                                <div className="result-box">
                                    <div className="circle-dimension">
                                        <CircularProgressbarWithChildren strokeWidth="7" value={percentage} styles={buildStyles({ textColor: '#FD9D60', textSize: '28px', trailColor: '#E8E8E8', pathColor:  circleColor(percentage) })}>
                                            <div className="score" style={{color:`${circleColor(percentage)}`}}>{`${percentage}%`}</div>
                                            <div className="strength" style={{color:`${circleColor(percentage)}`}}>
                                                {resume.resume_review?.resume_score?.resume_strength}
                                            </div>
                                        </CircularProgressbarWithChildren>
                                    </div>
                                    <span>Power Score</span>
                                </div>
                                <div className="info-details">
                                    <h2>{STRENGTH_LEVEL[strengthLevel] ? STRENGTH_LEVEL[strengthLevel].msg : ''}</h2>
                                    <span>{STRENGTH_LEVEL[strengthLevel] ? STRENGTH_LEVEL[strengthLevel].desc : ''}</span>
                                    {/* <span className="font-weight-500">Looks great! Good luck with job interview!</span> */}
                                </div>
                            </div>
                            <div className="common-box-container">
                            <SectionRow sectionid={'personal_details'} label="Personal Details" url={REVIEW_HEADING_LINK} />

                            <SectionRow sectionid={'work_history'} label="Professional Experience" url={REVIEW_WORKHISTORY_LINK} />

                            <SectionRow sectionid={'education_history'} label="Education" url={REVIEW_EDUCATION_LINK} />

                            <SectionRow sectionid={'skills'} label="Key Skills" url={REVIEW_SKILLS_LINK} />

                            <SectionRow sectionid={'summary'} label="Summary" url={REVIEW_SUMMARY_LINK} />
                            </div>

                        </div>
                    </div>
                    <div className="right-block">
                        <div className="right-block-inner">
                            <div className={`page-area ${props.editorType}-area`}>
                                <div className="resume-preview">
                                    <div id="resume-download">
                                        <div className="paper preview-resume" id="preview-resume">
                                            <div id="resume-page" className="page">
                                                {<Resumes data={resume} scale={scale} no_dummy={true} />}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> : <PageLoader />}
        </Fragment>
    )
}
export default ReviewLandingPage;